import styled from 'styled-components';
import { Checkbox } from 'antd';

const StyledCheckbox = styled(Checkbox)`
  /* stylelint-disable no-descending-specificity */
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #f0b90b;
    border-color: #f0b90b;
  }
  .ant-checkbox-disabled .ant-checkbox-inner {
    border-color: #d9d9d9 !important;
    background-color: #f5f5f5;
  }
  .ant-checkbox-checked:after {
    border-color: #f0b90b;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #f0b90b;
  }

  &:hover {
    .ant-checkbox-inner {
      border-color: #f0b90b;
    }
  }
`;

export default StyledCheckbox;
